//oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function onNumberChange(cb: (...event: any[]) => void) {
  return (e: React.ChangeEvent<Element>) => {
    e.preventDefault();
    const value = (e.target as HTMLInputElement).value;
    if (value === "") {
      cb("");
    }
    const number = parseInt(value);
    if (!isNaN(number)) {
      cb(number);
    } else {
      cb("");
    }
  };
}
